import { render, staticRenderFns } from "./ResultBoard.vue?vue&type=template&id=810ddf4e&scoped=true&"
import script from "./ResultBoard.vue?vue&type=script&lang=js&"
export * from "./ResultBoard.vue?vue&type=script&lang=js&"
import style0 from "./ResultBoard.vue?vue&type=style&index=0&id=810ddf4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "810ddf4e",
  null
  
)

export default component.exports